// Deployment settings: in Docker from the container's environment at runtime (env.js, written at
// container start from .env_org by docker/env.sh), else REACT_APP_* values from .env (npm start).
// See .env.example.
const runtimeEnv = window.__ENV__ || {};
const setting = (name, builtIn) => (runtimeEnv[name] || builtIn || '').replace(/\/+$/, '');

// Backend root: the API is at /api, logos under api/uploads/, and the plain WebSocket (Ratchet)
// server at /ws (https -> wss), proxied like in surveystud.com-new.
const BACKEND_URL = setting('BACKEND_URL', process.env.REACT_APP_BACKEND_URL);
export const BASE_URL = `${BACKEND_URL}/api`;
export const ROOT_URL = `${BACKEND_URL}/`;
export const WS_URL = `${BACKEND_URL.replace(/^http/, 'ws')}/ws`;

// Creator app (surveystud.com), linked from the voting pages.
export const FRONTEND_URL = setting('FRONTEND_URL', process.env.REACT_APP_FRONTEND_URL);

// Cloudflare Turnstile site key (public) of the bot check on the voting page. Its secret is
// TURNSTILE_SECRET_KEY in the backend .env.
export const TURNSTILE_SITE_KEY = setting('TURNSTILE_SITE_KEY', process.env.REACT_APP_TURNSTILE_SITE_KEY);

export const fake = '';
